import Page from './index';

export default { path: '/home/tenant/tenantOss', component: Page };
